import { render, staticRenderFns } from "./GetAform.vue?vue&type=template&id=56bcbb20&scoped=true&"
import script from "./GetAform.vue?vue&type=script&lang=js&"
export * from "./GetAform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bcbb20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56bcbb20')) {
      api.createRecord('56bcbb20', component.options)
    } else {
      api.reload('56bcbb20', component.options)
    }
    module.hot.accept("./GetAform.vue?vue&type=template&id=56bcbb20&scoped=true&", function () {
      api.rerender('56bcbb20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/LockerRoom/SubPages/GetAform.vue"
export default component.exports